import { useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useNavigate } from 'react-router-dom';
import { URL_Route } from 'urlRouts';
import { setInitialStateAction } from 'ReduxSaga/actions/UserActions'
import { useDispatch } from 'react-redux'

interface Props {
    children:any
}

const IdleTimer:React.FC<Props> = ({children}) => {
    const dispatch = useDispatch()
    const timeout = 1800000
    const navigate = useNavigate()
    const [isIdle , setIsIdle] = useState(false)
    const handleOnActive = () => setIsIdle(false)

    const handleOnIdle = () => { 
        setIsIdle(true)
        dispatch(setInitialStateAction())
        navigate(URL_Route.Login)
    }

    const {getRemainingTime } = useIdleTimer({
        timeout , 
        onActive : handleOnActive , 
        onIdle : handleOnIdle
    })

    return (
        children
    );
};

export default IdleTimer;